import React from 'react'

function Pnevmo({image}) {
  return (
    <div className='fullnkarner' >
    <div className='nkarner'>


      {image.map((item, index) => (

        <div key={index}>
          <img src={item.image} alt="" />
          {/* <div>
            <p>{item.anun}</p>
            <p>{item.gin}</p>
          </div> */}



        </div>
      ))}
    </div>
  </div>
  )
}

export default Pnevmo
